const API_KEY = process.env.REACT_APP_YANDEX_MAP_KEY
const API_URL = 'https://geocode-maps.yandex.ru/1.x'

/**
 * Получает адрес по координатам с помощью API Яндекс.Геокодера.
 * @param {number[]} coords - Массив координат [longitude, latitude].
 * @returns {Promise<string|null>} - Строка с адресом или null в случае ошибки.
 */
export const getAddressFromCoords = async (coords) => {
  if (!API_KEY) {
    console.error(
      'Yandex Geocoder API key is missing. Please set REACT_APP_YANDEX_GEOCODER_API_KEY in your .env file.',
    )
    return null
  }

  const params = new URLSearchParams({
    apikey: API_KEY,
    format: 'json',
    geocode: coords.join(','),
    results: 1,
  })

  try {
    const response = await fetch(`${API_URL}?${params}`)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const data = await response.json()
    const geoObject =
      data.response.GeoObjectCollection.featureMember[0]?.GeoObject
    return geoObject ? geoObject.name : null
  } catch (error) {
    console.error('Error fetching address from Yandex Geocoder API:', error)
    return null
  }
}
